import ItnAPI from './_integrationApi.js';
import httpClient from '@/apis/base/httpclient';

class IntegrationAgreementContractApi extends ItnAPI {
  constructor() {
    super();
  }
  controllerName = 'AgreementContracts';
  /**
   * Kiểm tra thỏa thuận sử dụng
   * @param {*} param
   * @returns
   */
  checkAgreementApp() {
    let request = {
      url: this.getAPIUrl() + '/CheckAgreementApp',
    };
    return this.getAsync(request);
  }

   /**
   * Lấy link show lịch sử thỏa thuận
   * @param {*} param
   * @returns
   */
    getLinkAgreementHistory() {
      let request = {
        url: this.getAPIUrl() + '/GetLinkAgreementHistory',
      };
      return this.getAsync(request);
    }
  

  /**
   * Lưu thỏa thuận sử dụng
   * @param {*} param
   */
  saveAgreementLicense(param) {
    let request = {
      url: this.getAPIUrl() + '/SaveAgreementLicense',
      data: param,
    };
    return this.postAsync(request);
  }

  /**
   * Lấy danh sách các thỏa thuận sử dụng
   * @param {*} param
   * @returns
   */
  getAgreementLicense(param) {
    let request = {
      url: this.getAPIUrl() + '/GetAgreementLicense',
      data: param,
    };
    return this.getAsync(request);
  }

  /**
   * Lấy danh sách các thỏa thuận sử dụng và quyền riêng tư luồng mới
   * @param {*} param
   * @returns
   */
   getLinkAgreementByType(param) {
    let request = {
      url: this.getAPIUrl() + '/GetLinkAgreementByType',
      data: param,
    };
    return this.getAsync(request);
  }
}
export default new IntegrationAgreementContractApi();
